export const CONSTANTS = {
  PRODUCT_NAME: 'Megapack Fútbol Listo',
  PAYMENT_LINK:
    'https://elrincondigital.click/checkouts/cn/hWNAo9UB2RlRQ7NTbb5Ko4o6/es-ar?_r=AQABldu0kbPYysHP-R7B2qT6bm0BBpPGOYdKOMLdqRUw1yo&preview_theme_id=154785841310',
  PIXEL_ID: '1225428543097695',
  IMAGES: {
    MAIN_PRODUCT:
      'https://cdn.magicpatterns.com/uploads/boTHhVhcx9Bw9KcDaSLD8H/futbol.png',
    COMBO:
      'https://cdn.magicpatterns.com/uploads/qF2tofB5xEJjeUYgJrBZ8V/Combo_completo_para_entrenadores_de_futbol.png',
    BONUS_1:
      'https://images.unsplash.com/photo-1518605368461-1e1e38ce8058?auto=format&fit=crop&q=80&w=400',
    BONUS_2:
      'https://images.unsplash.com/photo-1434682881908-b43d0467b798?auto=format&fit=crop&q=80&w=400',
    BONUS_3:
      'https://images.unsplash.com/photo-1574629810360-7efbb1925536?auto=format&fit=crop&q=80&w=400',
    BONUS_4:
      'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?auto=format&fit=crop&q=80&w=400',
    BONUS_5:
      'https://images.unsplash.com/photo-1517649763962-0c623066013b?auto=format&fit=crop&q=80&w=400',
    BONUS_6:
      'https://images.unsplash.com/photo-1552674605-171ff5ea36ee?auto=format&fit=crop&q=80&w=400',
  },
  PRICING: {
    ORIGINAL: 39900,
    SALE: 19900,
    SAVINGS_PERCENTAGE: 50,
    CURRENCY: '$',
    INDIVIDUAL_VALUE: 7900,
    BONUS_VALUE: 5900,
    TOTAL_VALUE: 43300,
  },
}
